<template>
  <v-list>
    <v-card-text v-if="ready">
      <v-subheader>
        Разрешения
      </v-subheader>
      <v-list>
        <v-switch class="pl-3"
        label="покупки в торговых автоматах"
        v-model="permissions" value="vending"
        @change="() => update('vending')"
        ></v-switch>
      </v-list>
    </v-card-text>
    <v-progress-linear v-else indeterminate></v-progress-linear>
  </v-list>
</template>

<script>
export default {
  name: 'settings-permissions',
  props: ['profile'],
  data: () => ({
    permissions: null
  }),
  methods: {
    async fetch () {
      const { permissions } = await this.$store.dispatch('sioRequest', {
        topic: 'permissions',
        pl: {}
      })
      this.permissions = permissions.map(x => x.type)
    },
    async add (type) {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'permissions-add',
          pl: { type }
        })
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.fetch()
      }
    },
    async del (type) {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'permissions-delete',
          pl: { type }
        })
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.fetch()
      }
    },
    update (type) {
      if (this.permissions.includes(type)) {
        this.add(type)
      } else {
        this.del(type)
      }
    }
  },
  computed: {
    ready () {
      return this.profile && (typeof this.permissions !== 'undefined')
    }
  },
  watch: {
    // eslint-disable-next-line
    async profile (val, old) {
      if (val) await this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>

<style lang="css">
</style>
